import { notificationsMixin } from '@/mixins/notifications';

export const cardUseModalMixin = {
  mixins: [notificationsMixin],
  data() {
    return {
      cardUseModalMixin: {
        cardUseModal: false,
        cardNumber: undefined
      }
    };
  },
  methods: {
    // @vuese
    // Handler odczytu karty z czytnika
    // @arg `cardNumber` numer karty odczytany przy pomocy czytnika
    async cardReaderHandler(cardNumber) {
      if (cardNumber) {
        try {
          this.cardUseModalMixin.cardNumber = cardNumber;
          await this.$store.dispatch('partners/benefits/available/list', cardNumber);
          this.showModal();
        } catch (error) {
          this.notifyError('Nie znaleziono klienta przypisanego do tej karty.');
          console.warn(error);
        }
      }
    },
    // @vuese
    // Zamknięcie modala
    hideModal() {
      this.cardUseModalMixin.cardUseModal = false;
      this.cardUseModalMixin.cardNumber = undefined;
    },
    // @vuese
    // Otworzenie modala
    showModal() {
      this.cardUseModalMixin.cardUseModal = true;
    }
  }
};
